import React, { FunctionComponent, useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next";
import { NextRouter, useRouter } from "next/router";
import { CircularProgress, Stack } from "@mui/material";
import { getSafeReturnUrl } from "merchant-core";
import { useMerchant } from "../hooks/api/useMerchant";

const getReturnUrl = (router: NextRouter): string | null => {
  return getSafeReturnUrl(router?.query?.returnUrl, "/dashboard");
};

const getMerchantDefaultRedirectUrl = (
  merchant: ReturnType<typeof useMerchant>["data"],
): string => {
  const merchantPlatform = (merchant?.platform || "").toLowerCase();

  if (!merchant?.isIntegrationVerified && merchantPlatform === "wix") {
    return "/welcome";
  }

  return "/dashboard";
};

const Index: FunctionComponent = () => {
  const router = useRouter();
  const returnUrl = getReturnUrl(router);
  const { data: merchant, isLoading } = useMerchant();
  const redirectUrl =
    returnUrl || (isLoading ? null : getMerchantDefaultRedirectUrl(merchant));

  useEffect(() => {
    if (redirectUrl) {
      router.replace(redirectUrl);
    }
  }, [redirectUrl, router]);

  if (isLoading && !redirectUrl) {
    return (
      <Stack alignItems="center" mt="40px">
        <CircularProgress size={50} color="secondary" />
      </Stack>
    );
  }

  return <></>;
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale && (await serverSideTranslations(locale, ["common"]))),
    },
  };
};
